import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-3 col-lg-3 col-md-6 col-sm-6" }
const _hoisted_3 = { class: "col-xxl-3 col-lg-3 col-md-6 col-sm-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header border-0 pt-5" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "col"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search fs-4 me-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex justify-content-end" }, null, -1)
const _hoisted_13 = { class: "card-body pt-0" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_16 = {
  key: 2,
  class: "badge badge-primary"
}
const _hoisted_17 = {
  key: 0,
  class: "text-success"
}
const _hoisted_18 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsWidget5 = _resolveComponent("StatisticsWidget5")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_UpdateNote = _resolveComponent("UpdateNote")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_StatisticsWidget5, {
          "widget-classes": "card-xl-stretch mb-8",
          "svg-icon": "/media/icons/duotune/finance/fin006.svg",
          color: "info",
          "icon-color": "white",
          title: _ctx.$n(_ctx.$store.state.AuthModule.user.al_wallet, 'currency'),
          description: _ctx.$t('DashboardSummary.CurrentAl')
        }, null, 8, ["title", "description"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_StatisticsWidget5, {
          "widget-classes": "card-xl-stretch mb-8",
          "svg-icon": "/media/icons/duotune/finance/fin001.svg",
          color: "success",
          "icon-color": "white",
          title: _ctx.$n(_ctx.totalUsage, 'currency'),
          description: _ctx.$t('AlHistory.TotalUsage')
        }, null, 8, ["title", "description"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.search.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.search.type = $event)),
              class: "bg-body"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.search.type !== 'SETTLEMENT')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.search.agent,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search.agent = $event)),
                  class: "bg-body"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subagents, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_DateRangePicker, {
              onChangedate: _ctx.setSelectedDate,
              initial: "month"
            }, null, 8, ["onChangedate"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              href: "#",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getAlHistories && _ctx.getAlHistories(...args)))
            }, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("MoneyTransfer.Search")), 1)
            ])
          ])
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-memo": _withCtx(({ row: history }) => [
            (
              history.memo === 'ADD' ||
              history.memo === 'SUB_DEDUCT' ||
              history.memo === 'POINT'
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("Deposit." + history.memo)), 1))
              : (history.memo === 'DEDUCT' || history.memo === 'SUB_ADD')
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("Deposit." + history.memo)), 1))
                : (history.memo === 'SETTLEMENT')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("AlHistory.Settlement")), 1))
                  : _createCommentVNode("", true)
          ]),
          "cell-amount": _withCtx(({ row: history }) => [
            (Number(history.amount) >= 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$n(Number(history.amount))), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$n(Number(history.amount))), 1))
          ]),
          "cell-notes": _withCtx(({ row: history }) => [
            _createElementVNode("span", null, _toDisplayString(history.notes), 1),
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-info btn-sm me-3",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_memo_update",
              onClick: ($event: any) => (_ctx.onSelectHistory(history.id))
            }, _hoisted_21, 8, _hoisted_19)
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ]),
      _createVNode(_component_UpdateNote, {
        onRefresh: _ctx.getAlHistories,
        historyId: _ctx.selectedHistory
      }, null, 8, ["onRefresh", "historyId"])
    ])
  ], 64))
}